var render = function render(){var _vm=this,_c=_vm._self._c;return _c('feather-icon',{staticClass:"mt-1 mx-4 text-grey",attrs:{"icon":"BellIcon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }